import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "masterplan-upload" }
const _hoisted_2 = { class: "upload-section" }
const _hoisted_3 = {
  key: 0,
  class: "upload-content"
}
const _hoisted_4 = {
  key: 1,
  class: "file-selected"
}
const _hoisted_5 = { class: "file-info" }
const _hoisted_6 = { class: "file-name" }
const _hoisted_7 = { class: "file-size" }
const _hoisted_8 = {
  key: 2,
  class: "parsing"
}
const _hoisted_9 = {
  key: 0,
  class: "parse-results"
}
const _hoisted_10 = { class: "summary" }
const _hoisted_11 = { class: "summary-item" }
const _hoisted_12 = { class: "summary-value" }
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = { class: "summary-value" }
const _hoisted_15 = { class: "summary-item" }
const _hoisted_16 = { class: "summary-value" }
const _hoisted_17 = { class: "summary-item" }
const _hoisted_18 = { class: "summary-value" }
const _hoisted_19 = { class: "summary-item" }
const _hoisted_20 = { class: "summary-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[11] || (_cache[11] = _createElementVNode("h2", null, "Upload SVG Masterplan", -1)),
      _cache[12] || (_cache[12] = _createElementVNode("p", null, "Upload your estate masterplan as an SVG file. The system will automatically detect all shapes (rectangles, paths, polygons) that can be mapped to lots.", -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["file-upload", { 'drag-over': $setup.isDragging }]),
        onDragover: _withModifiers($setup.handleDragOver, ["prevent"]),
        onDragleave: _withModifiers($setup.handleDragLeave, ["prevent"]),
        onDrop: _withModifiers($setup.handleDrop, ["prevent"])
      }, [
        _createElementVNode("input", {
          ref: "fileInput",
          type: "file",
          accept: ".svg,image/svg+xml",
          onChange: $setup.handleFileSelect,
          hidden: ""
        }, null, 544),
        (!$setup.selectedFile && !$setup.uploading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "upload-icon" }, "📁", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "upload-text" }, "Drag and drop your SVG file here", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", { class: "upload-subtext" }, "or", -1)),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: $setup.triggerFileSelect
              }, "Browse Files")
            ]))
          : _createCommentVNode("", true),
        ($setup.selectedFile && !$setup.uploading && !$setup.parseResult)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "file-icon" }, "📄", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.selectedFile.name), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatFileSize($setup.selectedFile.size)), 1)
              ]),
              _createElementVNode("button", {
                class: "btn-secondary",
                onClick: $setup.clearFile
              }, "Remove"),
              _createElementVNode("div", { class: "parse-section" }, [
                _createElementVNode("button", {
                  class: "btn-primary",
                  onClick: $setup.handleParseSvg
                }, "Parse SVG and Detect Elements")
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.uploading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "spinner" }, null, -1),
              _createElementVNode("p", null, "Parsing SVG...", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 34),
      ($setup.parseResult && !$setup.uploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("h3", null, "SVG Elements Detected", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "summary-label" }, "Total Elements", -1)),
                _createElementVNode("div", _hoisted_12, _toDisplayString($setup.parseResult.elements.length), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "summary-label" }, "Rectangles", -1)),
                _createElementVNode("div", _hoisted_14, _toDisplayString($setup.elementsByType.rect), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "summary-label" }, "Paths", -1)),
                _createElementVNode("div", _hoisted_16, _toDisplayString($setup.elementsByType.path), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "summary-label" }, "Polygons", -1)),
                _createElementVNode("div", _hoisted_18, _toDisplayString($setup.elementsByType.polygon), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "summary-label" }, "Circles", -1)),
                _createElementVNode("div", _hoisted_20, _toDisplayString($setup.elementsByType.circle), 1)
              ])
            ]),
            _createElementVNode("div", { class: "action-buttons" }, [
              _createElementVNode("button", {
                class: "btn-secondary",
                onClick: $setup.clearAll
              }, "Start Over"),
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: $setup.handleContinue
              }, "Continue to Lot Matching →")
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}